"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartConfigSelect = void 0;
var react_1 = __importDefault(require("react"));
var footerSelect_1 = require("./footerSelect");
var lodash_1 = __importDefault(require("lodash"));
exports.ChartConfigSelect = function (props) {
    if (lodash_1.default.isEmpty(props.labels)) {
        return null;
    }
    return react_1.default.createElement(footerSelect_1.FooterSelect, { disabled: props.disabled, options: props.labels.map(function (l) { return ({ value: l, label: l }); }), selectedLabel: props.selectedLabel, onSelectedChange: props.onSelectedChange, menuPlacementTop: props.menuPlacementTop });
};
